import { Help } from '@plasma/ui.application.app';

const help: Help[] = [
  // {
  //   title: 'FaqServiceSupport',
  //   description: 'description of FaqServiceSupport',
  //   url: '/faq-service-support',
  // },
];

export default help;
